import React from 'react';
import {Box, Skeleton, VStack} from '@tempo/core';

const SectionRowSkeleton = () => {
	return (
		<Box
			pt={{base: 'spacing.l', md: 'spacing.xl'}}
			pb={{base: 'spacing.s', md: 'spacing.m'}}
			px={{base: 'spacing.l', md: 'spacing.xl'}}
			borderTopStyle={'solid'}
			borderBottomStyle={'solid'}
			borderBottomWidth={'1px'}
			borderTopWidth="1px"
			borderColor="divider.neutral.primary.default"
			bg="background.neutral.secondary.default"
		>
			<VStack alignItems="initial" spacing="spacing.xs">
				<Skeleton height="20px" width="60%" />
				<Skeleton height="16px" width="40%" />
			</VStack>
		</Box>
	);
};

export default SectionRowSkeleton;
